import {
  ADD_SITE,
  DELETE_SITE,
  LOAD_SITES,
  UPDATE_SITE,
} from '../../config/actions';

const initialState = {
  sites: {
    data: [],
    pagination: { total: 0, page: 0, limit: 0, totalPages: 0 },
  },
};

const sites = (state = initialState, action) => {
  const { type, payload, append } = action;

  switch (type) {
    case LOAD_SITES: {
      // When append = true, merge data, else replace
      if (append) {
        return {
          ...state,
          sites: {
            data: [...(state.sites.data || []), ...(payload.data || [])],
            pagination: payload.pagination || state.sites.pagination,
          },
        };
      } else {
        return {
          ...state,
          sites: payload,
        };
      }
    }

    case ADD_SITE: {
      const newSite = payload;
      return {
        ...state,
        sites: {
          ...state.sites,
          data: [newSite, ...(state.sites.data || [])],
        },
      };
    }

    case UPDATE_SITE: {
      const { id, name, url } = payload;
      const updatedData = (state.sites.data || []).map((s) =>
        s.id === id ? { ...s, name, url } : s
      );
      return {
        ...state,
        sites: {
          ...state.sites,
          data: updatedData,
        },
      };
    }

    case DELETE_SITE: {
      const remainingData = (state.sites.data || []).filter(
        (s) => s.id !== payload.id
      );
      return {
        ...state,
        sites: {
          ...state.sites,
          data: remainingData,
        },
      };
    }
    
    default:
      return state;
  }
};

export default sites;
